import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  exportReceive (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorderexport', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  searchReceive (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorder', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addReceiveorder (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'receiveorder', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addReceiveorderItem (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'receiveorderitem', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editReceive (URL, obj, header, success, error) {
    Vue.axios.put(URL + 'receiveorder', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  cancelReceive (URL, header, success, error) {
    Vue.axios.delete(URL + 'receiveordercancel', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  cancelReceiveDetail (URL, header, success, error) {
    Vue.axios.delete(URL + 'receiveorderdetailcancel', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeReceive (URL, header, success, error) {
    Vue.axios.delete(URL + 'receiveorder', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveByID (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorderbyid', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSuplierReceive (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorder/suplier', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDockStore (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorder/dock', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPartStore (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorder/partstore', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveSerial (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorderserial', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveDetail (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorderdetail', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveDetailExport (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorderdetailexport', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveDetailByID (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorderdetailbyid', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addReceiveDetail (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'receiveorderdetail', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editReceiveDetail (URL, obj, header, success, error) {
    Vue.axios.put(URL + 'receiveorderdetail', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeReceiveDetail (URL, header, success, error) {
    Vue.axios.delete(URL + 'receiveorderdetail', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addSerialTemp (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'importsorder/temp', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getOrderDetail (URL, header, success, error) {
    Vue.axios.get(URL + 'confirmorder/orderdetail', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getOrderDetailItem (URL, header, success, error) {
    Vue.axios.get(URL + 'confirmorder/orderdetailitem', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  searchReceiveConfirm (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorderconfirm', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editReceiveConfirm (URL, obj, header, success, error) {
    Vue.axios.put(URL + 'receiveorderconfirm', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  checkReceiveConfirm (URL, header, success, error) {
    Vue.axios.get(URL + 'receiveorderconfirmcheck', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/receiveorder.js